
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import dynamic from 'next/dynamic';
import SEO from 'global/SEO';
import usePublicProtectedRoute from 'hooks/usePublicProtectedRoute';
import 'react-phone-input-2/lib/style.css';

const Register = dynamic(() => import('features/register'));
const AuthLayout = dynamic(() => import('global/AuthLayout'));

function RegisterPage() {
  usePublicProtectedRoute();

  return (
    <AuthLayout>
      <SEO />
      <Register />
    </AuthLayout>
  );
}

export default RegisterPage;
